module.exports = __webpack_public_path__ + "static/demoeapcompany-logo-c3ebeb8503e02e7f980abc744e13b573.png";